import React, { FC } from 'react'
import { BtnComponent, FormNotificationComponent, Heading, i18n, Indent, UITypes } from 'LibNeo'
import { useAppDispatch } from 'Src/hooks/useAppDispatch'
import { Callback } from 'Src/types/utilTypes'
import { OrderBuildRequest, ordersSlice } from 'Pages/orders_design'

const actions = {
	buildOrder: ordersSlice.actions.buildOrder,
}

interface ComponentProps {
	orderPayload: OrderBuildRequest
	close?: Callback
	title: string
	text: string
}
export const ReassignMobileModal: FC<ComponentProps> = ({ orderPayload, close, title, text }) => {
	const { buildOrder } = useAppDispatch(actions)
	const mainAction = () => {
		buildOrder({ ...orderPayload, accept_blocked: true })
		close()
	}
	return (
		<>
			<Heading type="h5">{i18n(title)}</Heading>
			<Indent top={24}>
				<FormNotificationComponent
					message={text}
					hideIcon
					type={UITypes.WARNING}
					title="Клиент закреплен за другим партнером"
				/>
			</Indent>
			<Indent top={24}>
				<BtnComponent block title="Подать с перезакреплением" outline onClick={mainAction} />
				<Indent top={16}>
					<BtnComponent type={UITypes.WARNING} title="Закрыть" onClick={close} block />
				</Indent>
			</Indent>
		</>
	)
}
